/**
 * The Pattern style tile's glyph, in the same 30 × 15 frame and stroke as the
 * served tiles' `SettingIcon`: a graduated sweep across the band — the one
 * thing a pattern can do that no row style can.
 */
const DOTS = [
  { x: 5, y: 10.6, r: 0.9 },
  { x: 8.4, y: 9.4, r: 1.15 },
  { x: 12.2, y: 8.0, r: 1.45 },
  { x: 16.4, y: 6.8, r: 1.75 },
  { x: 20.6, y: 5.8, r: 1.45 },
  { x: 24.2, y: 5.0, r: 1.15 },
];

export function PatternTileIcon({ size = 34 }: { size?: number }) {
  const W = 30;
  const H = 15;
  return (
    <svg width={size} height={(size * H) / W} viewBox={`0 0 ${W} ${H}`} aria-hidden="true" className="text-primary">
      <rect x={0.7} y={0.7} width={W - 1.4} height={H - 1.4} rx={3} fill="none" stroke="currentColor" strokeWidth={0.9} opacity={0.45} />
      {DOTS.map((d, i) => (
        <circle key={i} cx={d.x} cy={d.y} r={d.r} fill="currentColor" />
      ))}
    </svg>
  );
}
